import React , { Component} from 'react'
import {withStyles, Grid, IconButton, Badge} from '@material-ui/core'
import {FilterFrames, 
        TextsmsOutlined,
        CloseOutlined, 
        Equalizer, 
        RoomOutlined,
        Print,
        Create,Notifications} from '@material-ui/icons'
import GamePlayerHand from './gamePlayerHand'
import GameGeneralChat from './gameGeneralChat'
import GameVote from './gameVote'
import GameEditor from './gameEditor'
import GamePinned from './gamePinned'
import NotificationLog from './notificationLog'
import GameOutput from './gameOutput'
import Loader from '../../loader'
import EE from '../../../api/eventemitter'
import socket from '../../../api/socket'

const styles = {
    container: {
        display: "flex",
        flexFlow: "column",
        height: "calc(100% - 7rem)",
        width: "250px",
        position: "fixed",
        zIndex: "3",
        fontFamily: "Arial",
        top: "7rem",
        right: "0",
        background: "#E1E1E1",
        transition: "0.5s",
        opacity: "0.99",
    },

    header:{
        padding:"1rem",
        fontWeight:"bold",
        color:"#4F4F4F",
        fontSize:"18px",
    },
      
    closebtn: {
        marginTop:"4px",
        color: "#4F4F4F",
        "&:focus":{
            outline:"none"
        }
    },
      
    openbtn: {
        color: "#4f4f4f",
        display:"block",
        cursor:"pointer",
        padding:"0.75rem",
        transition:".5s",
        borderRadius:"0px",
        "&:focus":{
            outline:"none"
        },
        "&:hover":{
            background:"rgba(0,0,0,0.5)"
        },
    },
    
    active:{
        //color:"black",
        background: "rgba(0,0,0,0.1)"
    },

    main: {
        transition: ".5s",
        height:"calc(100% - 7rem)",
        background:"#DBDBDB",
        position:"fixed",
        top: "7rem",
        right: "0",
        zIndex:"4",
        marginRight:"250px"
    },

    show:{
        display: "block",
        flex:"1",
        overflowY: 'auto'
    },

    hide:{
        display: "none",
    },
}
class GameRightPanel extends Component {
    constructor(props){
        super(props)
        this.sidebar = React.createRef();
        this.main = React.createRef();
        this.state = {
            deck: [],
            open: "My Hand",
            messageCount: 0,
            usedDeck: this.props.usedDeck,
            historySelect: "current"
        }

        this.gameDeck = null;

    }

    componentDidMount(){
        EE.on("Call for Vote", () => {
            this.openNav("Vote")
        })

        EE.on("Update Output",(data)=>{
            const {field,value,index} = data
            console.log(data)
            

        })

        socket.on("Call for Vote", () =>{
            this.openNav("Vote")
        })
    }
    
    render(){
        const {classes, automation, inhand, gid, participants, isLeader} = this.props
        // console.log(this.props.history)
        // this.openNav("My Hand")
        if(this.state.usedDeck){
            // console.log(this.state.usedDeck)
            return (
                <>
                    <div onClick={()=>{EE.emit("Canvas Defocus")}} ref={this.sidebar} className={classes.container}>
                        <Grid container>
                            <Grid item xs={9}>
                                <h1 id="header" className={classes.header}>{this.state.open!== "none" && this.state.open}</h1>
                            </Grid>
                            <Grid item xs={3}>
                                <center>
                                    <IconButton className={classes.closebtn} onClick={this.closeNav}>
                                        <CloseOutlined/>
                                    </IconButton> 
                                </center>
                            </Grid>
                        </Grid>
                        <div className={this.state.open === "Chat" ? classes.show : classes.hide}>
                            <GameGeneralChat
                                participants={this.props.participants}
                                isOpen ={this.state.open === "chat" ? true : false}
                                updateMessageCount = {this.updateMessageCount}
                                messageCount = {this.state.messageCount}
                                gid = {gid}
                                gameTranscript = {this.props.gameTranscript}
                                isSpectate = {this.props.isSpectate}
                                spectateInfo = {this.props.spectateInfo}

                            />
                        </div>
                        <div className={`game-hand ${this.state.open === "My Hand" ? classes.show : classes.hide}`}>
                            <GamePlayerHand 
                                deckConfig={this.props.deckConfig} 
                                listPinIds={this.props.listPinIds}
                                participants={this.props.participants} 
                                automation={automation} 
                                gameDeck={this.state.usedDeck} 
                                inhand={inhand} gid={gid} 
                                createdBy={this.props.createdBy}
                                categoryColorMap={this.props.categoryColorMap}
                                imgData = {this.props.imgData}
                                onImgUpload = {this.props.onImgUpload}
                                onImgPaste = {this.props.onImgPaste}
                                removeImg = {this.props.removeImg}
                                onDrop = {this.props.onDrop}
                                playerList = {this.props.playerList}
                                libraryObjects = {this.props.libraryObjects}
                            />
                        </div>
                        <div className={this.state.open === "Pinned" ? classes.show : classes.hide}>
                            <GamePinned
                                categoryColorMap={this.props.categoryColorMap}
                                listPinIds={this.props.listPinIds}
                                pinRightPanel={this.props.pinRightPanel}
                                libraryObjects={this.props.libraryObjects}
                                inhand={inhand}
                                imgData = {this.props.imgData}
                                onImgUpload = {this.props.onImgUpload}
                                onImgPaste = {this.props.onImgPaste}
                                removeImg = {this.props.removeImg}
                                onDrop = {this.props.onDrop}
                                />
                        </div>
                        <div className={this.state.open === "Vote" ? classes.show : classes.hide}>
                            <GameVote
                                listPinIds={this.props.listPinIds}
                                categoryColorMap={this.props.categoryColorMap}
                                imgData = {this.props.imgData}
                                onImgUpload = {this.props.onImgUpload}
                                onImgPaste = {this.props.onImgPaste}
                                removeImg = {this.props.removeImg}
                                onDrop = {this.props.onDrop}
                            />
                        </div>
                        <div className={this.state.open === "Notification Log" ? classes.show : classes.hide}>
                            <NotificationLog
                                participants={this.props.participants}
                            />
                        </div>
                        <div className={this.state.open === "Jam Output" ? classes.show : classes.hide}>
                            <GameOutput
                                gid = {gid}
                                participants={this.props.participants}
                            />
                        </div>

                        {/* <div className={this.state.open === "Version History" ? classes.show : classes.hide}>
                            {this.props.history ?
                                    <ul style={{ fontSize:"13px", padding:"0 0 0 1.2em", marginLeft:"1em" }}>
                                    <li
                                        onClick={() => this.setState({ historySelect:"current" })}
                                        style={{
                                            cursor:"pointer",
                                            marginBottom:"8px",
                                            color: this.state.historySelect === "current" ? "#fa841b" : "#4F4F4F",
                                            fontWeight: this.state.historySelect === "current" ? "bold" : "normal",
                                        }}
                                    >
                                        Current
                                    </li>
                                    {this.props.history.map((n, index) => (
                                        <li
                                            key={index}
                                            onClick={() => this.setState({ historySelect: index })}
                                            style={{
                                                cursor:"pointer",
                                                marginBottom:"8px",
                                                color: this.state.historySelect === index ? "#fa841b" : "#4F4F4F",
                                                fontWeight: this.state.historySelect === index ? "bold" : "normal",
                                            }}
                                        >
                                            {n.date}
                                        </li>
                                    ))}
                                    </ul>
                                :
                                    <p style={{ fontSize:"13px", color:"#C4C4C4" }}>No Commits</p>
                            }
                        </div> */}

                        <div className={this.state.open === "Version History" ? classes.show : classes.hide}>
    {this.props.history ?
        <ul style={{ fontSize:"13px", padding:"0", margin:"0", listStyle:"none" }}>
            {/* Current Item */}
            <li style={{ marginBottom:"4px" }}>
                <div
                    // onClick={() => this.setState(prev => ({
                    //     historySelect: prev.historySelect === "current" ? null : "current"
                    // }))}

                    onClick={()=>{
                        EE.emit("Change Version",{hs:"current"})
                        this.setState(prev => ({
                            historySelect: prev.historySelect === "current" ? null : "current"
                        }))
                    }}
                    style={{
                        cursor: "pointer",
                        padding: "6px 10px",
                        borderRadius: "4px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        backgroundColor: this.state.historySelect === "current" ? "#fff4ec" : "transparent",
                        color: this.state.historySelect === "current" ? "#fa841b" : "#4F4F4F",
                        fontWeight: this.state.historySelect === "current" ? "bold" : "normal",
                    }}
                >
                     <span style={{ fontSize:"10px" }}>
                        {this.state.historySelect === "current" ? "▲" : "▼"}
                    </span>
                    <span>Current</span>

                </div>

                {/* Expanded Content */}
                {this.state.historySelect === "current" && (
                    <div style={{
                        padding: "8px 10px",
                        borderLeft: "2px solid #fa841b",
                        marginLeft: "10px",
                        marginTop: "2px",
                    }}>
                        <button
                            onClick={() => EE.emit("Create Branch")}
                            style={{
                                backgroundColor: "#fa841b",
                                color: "#fff",
                                border: "none",
                                borderRadius: "4px",
                                padding: "5px 12px",
                                fontSize: "12px",
                                cursor: "pointer",
                                width: "100%",
                            }}
                        >
                            Create Branch
                        </button>
                    </div>
                )}
            </li>

            {/* History Items */}
            {this.props.history.map((n, index) => (
                <li key={index} style={{ marginBottom:"4px" }}>
                    <div
                        // onClick={() => this.setState(prev => ({
                        //     historySelect: prev.historySelect === index ? null : index
                        // }))}
                        onClick={()=>{
                            EE.emit("Change Version",{hs:index})
                            this.setState(prev => ({
                                historySelect: prev.historySelect === index ? null : index
                            }))
                        }}
                        style={{
                            cursor: "pointer",
                            padding: "6px 10px",
                            borderRadius: "4px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            backgroundColor: this.state.historySelect === index ? "#fff4ec" : "transparent",
                            color: this.state.historySelect === index ? "#fa841b" : "#4F4F4F",
                            fontWeight: this.state.historySelect === index ? "bold" : "normal",
                        }}
                    >
                        <span style={{ fontSize:"10px", marginRight:"6px" }}>
                            {this.state.historySelect === index ? "▲" : "▼"}
                        </span>
                        <span>{n.date}</span>
                    </div>

                    {/* Expanded Content */}
                    {this.state.historySelect === index && (
                        <div style={{
                            padding: "8px 10px",
                            borderLeft: "2px solid #fa841b",
                            marginLeft: "10px",
                            marginTop: "2px",
                        }}>
                            <button
                                onClick={() => EE.emit("Create Branch")}
                                style={{
                                    backgroundColor: "#fa841b",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "4px",
                                    padding: "5px 12px",
                                    fontSize: "12px",
                                    cursor: "pointer",
                                    width: "100%",
                                }}
                            >
                                Create Branch
                            </button>
                        </div>
                    )}
                </li>
            ))}
        </ul>
    :
        <p style={{ fontSize:"13px", color:"#C4C4C4" }}>No Commits</p>
    }
                        </div>

                        {
                            isLeader && 
                            <div className={this.state.open === "Editor" ? classes.show : classes.hide}>
                                <GameEditor
                                    listOfLabels={this.props.listOfLabels}
                                    listOfCategories={this.props.listOfCategories}
                                    categoryColorMap={this.props.categoryColorMap}
                                    changeColor={this.props.changeColor}
                                    changeCard={this.props.changeCard}
                                    cardSelected={this.props.cardSelected}
                                    imgData = {this.props.imgData}
                                    onImgUpload = {this.props.onImgUpload}
                                    onImgPaste = {this.props.onImgPaste}
                                    removeImg = {this.props.removeImg}
                                    selectedIDs = {this.props.selectedIDs}
                                    onDrop = {this.props.onDrop}
                                />
                            </div>
                        }

                    </div>
                    <div onClick={()=>{EE.emit("Canvas Defocus")}} ref={this.main} className={classes.main}>
                        <IconButton className={`${classes.openbtn} ${this.state.open === "My Hand" && classes.active}`} onClick={() => this.openNav("My Hand")}>
                            <span className="material-symbols-outlined">front_hand</span>
                        </IconButton>  
                        {/* <IconButton className={`${classes.openbtn} ${this.state.open === "Pinned" && classes.active}`} onClick={() => this.openNav("Pinned")}>
                            <RoomOutlined/>
                        </IconButton> */}
                        <IconButton className={`${classes.openbtn} ${this.state.open === "Chat" && classes.active}`} onClick={() => this.openNav("Chat")}>
                            <Badge badgeContent={this.state.messageCount} color="primary">
                                <TextsmsOutlined/>
                            </Badge>
                        </IconButton>
                        {/* <IconButton className={`${classes.openbtn} ${this.state.open === "Vote" && classes.active}`} onClick={() => this.openNav("Vote")}>
                            <Equalizer/>
                        </IconButton> */}
                        {isLeader &&
                            <IconButton className={`${classes.openbtn} ${this.state.open === "Editor" && classes.active}`} onClick={() => this.openNav("Editor")}>
                                <Create/>
                            </IconButton>
                        }
                        <IconButton className={`${classes.openbtn} ${this.state.open === "Jam Output" && classes.active}`} onClick={() => this.openNav("Jam Output")}>
                            <span className="material-symbols-outlined">output</span>
                        </IconButton>
                        <IconButton className={`${classes.openbtn} ${this.state.open === "Notification Log" && classes.active}`} onClick={() => this.openNav("Notification Log")}>
                            <span className="material-symbols-outlined">notifications</span>
                        </IconButton>

                        <IconButton className={`${classes.openbtn} ${this.state.open === "Version History" && classes.active}`} onClick={() => this.openNav("Version History")}>
                            <span className="material-symbols-outlined">restore</span>
                        </IconButton>
                        
                    </div>
                </>
            )             
        }else{
            return (<Loader/>)
        }
    }
    
    openNav = (focus) =>{
        if(this.state.open==="none"){
            this.props.panelOpen(false)
            this.main.current.style.marginRight = "250px";
        }
        this.setState({open: focus}, ()=>{
            this.props.panelOpen(true)
            this.sidebar.current.style.right = "0";
            this.main.current.style.marginRight = "250px";
            
            if(this.state.open==="Chat"){
                this.setState({
                    messageCount: 0
                });
            }

            if(focus === "Jam Output"){
                //EE.emit("Open Output")
            }

            if(focus === "Version History"){
                EE.emit("Open History")
            }
        })
    }

    closeNav = () => {
        this.main.current.style.marginRight= "0";
        this.sidebar.current.style.right = "-250px";
        this.props.panelOpen(false)
        this.setState({open: "none"})
    }

    updateMessageCount = (count) =>{
        if(this.state.messageCount !==  count){
            this.setState({
                messageCount: count
            });
        }

    }

}



export default withStyles(styles)(GameRightPanel)